'use strict';

var FirebaseIndirectArray = require('./FirebaseIndirectArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeUser = require('./KayleeUser');
var KayleeUtil = require('./KayleeUtil');
//var log = require('../log/Log').channel('KayleeUsers');

var KayleeUsers = {
    fromJson: fromJson,
    getUsers: getUsers,
};

function fromJson(data) {
    var reqProps = [ '$nodeCacheKey' ];
    return FirebaseIndirectArray.$fromJson(data, 'Users', reqProps, reqProps,
        function(data) {
            var node = KayleeCache.get(data.$nodeCacheKey);
            return getUsers(node);
        }
    );
}

// Returns a promise that resolves to a Users object that contains the users
// with access to the specified node.

function getUsers(node) {
    var key = 'Users for ' + node.$nodeType + ': ' + node.$id;
    var users = KayleeCache.get(key);

    if (users === null) {
        users = new Users(node);
        KayleeCache.put(key, users);
    }

    return users;
}

function Users(node) {
    var srcRef;

    this.$nodeType = 'users';
    this.$node = node;

    if (node.$nodeType === 'company') {
        srcRef = KayleeBase.app.database().ref('index/usersByCompany/' + node.$id);
    } else if (node.$nodeType === 'site') {
        srcRef = KayleeBase.app.database().ref('index/usersBySite/' + node.$id);
    } else if (node.$nodeType === 'room') {
        srcRef = KayleeBase.app.database().ref('index/usersByRoom/' + node.$id);
    } else {
        return Promise.reject(new Error('invalid node type ' + node.$nodeType));
    }

    FirebaseIndirectArray.call(this, srcRef, KayleeUser.getUser);
    KayleeUtil.bindPrototypeMethods(Users.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

Users.prototype = Object.create(FirebaseIndirectArray.prototype);
Users.prototype.constructor = Users;

Users.prototype.$toJson = function() {
    return FirebaseIndirectArray.prototype.$toJson.call(this,
        [], { $nodeCacheKey: this.$node.$cacheKey });
};

Users.prototype.toString = function() {
    return '[Users for ' + this.$node + ']';
};

module.exports = KayleeUsers;
